export default "__VITE_ASSET__CD5nwDT8__"